// extracted by mini-css-extract-plugin
export default {"rootCenteredContent":"_2GItJ"};